export default __webpack_public_path__ + "static/media/hamburger-icon.23942915.svg";